module.exports = __webpack_public_path__ + "static/media/vpribory.1214551f.jpg";